import React, { useState, useEffect } from "react";
import {
  Card,
  CardText,
  CardTitle,
  FileInput,
  Cell,
  Grid,
  TextField,
  Button,
  SelectField
} from "react-md";
import { Slider } from "react-md";
import "../../css/mediaCss.css";
import Toggle from "react-toggle";
import { gridUnitSizes } from "./commonHelpers";
import { DEFAULT_VECTOR_SNAP_TO_GIRD } from "../../pages/AssignmentMatrix/Constants";
import { NotificationManager } from "react-notifications";
import SFInfoTooltip from "../../pages/AssignmentMatrix/components/SFInfoTooltip";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { PiCaretDown } from "react-icons/pi";
import { Box } from "@mui/material";
import ReactTooltip from 'react-tooltip';
import { HiInformationCircle } from "react-icons/hi";


let imageWidthGlobal, imageHeightGlobal;

const VectorCanvasSettings = ({ variableMap, classNameString, settings, onChange, answerList }) => {
  const settingsData = settings?JSON.parse(JSON.stringify(settings)):null;
  const [imageButton, setImageButton] = useState(true);
  const [oriWidth,setOriWidth] = useState(settingsData.imageWidthUnit);
  const [oriHeight,setOriHeight] = useState(settingsData.imageHeightUnit);
  //console.log("oriWidth = ", oriWidth)
  //console.log("oriHeight = ", oriHeight)

  const imageToBase64 = (src) =>  {
   
    return new Promise(
      function (resolve, reject) {
          let reader = new FileReader();
          reader.addEventListener(
        'load',
        function assignImageSrc(evt) {
        
          let imgSrc = evt.target.result;
          this.removeEventListener('load', assignImageSrc);
          resolve(imgSrc);
        },
        true
      );
      reader.readAsDataURL(src);
      });
  }

  const getImageDimensions = (file) =>  {
    return new Promise(
      function (resolve, reject) {
        let images = new Image();
        images.onload = () => {
          imageWidthGlobal = images.width
          imageHeightGlobal = images.height
         resolve({width:images.width, height:images.height});
        }
        let fileReader = new FileReader();
        fileReader.onload = () => images.src = fileReader.result;
        if (file) {
           fileReader.readAsDataURL(file);
        }
      });
  }

  const getCorrectedHeight = () =>  {
    if(settingsData.widthUnit){
      return ((settingsData.widthUnit/imageWidthGlobal)*imageHeightGlobal).toFixed(1);
    }
    return 0
  }

  const getCorrectedWidth = () =>  {
    if(settingsData.heightUnit){
      return ((settingsData.heightUnit/imageHeightGlobal)*imageWidthGlobal).toFixed(1);
    }
    return 0
  } 


const onImageSelected = (file) => {
    setImageButton(false) 
    imageToBase64(file).then((result) => {
        settingsData.image = result;
        onChange(settingsData);
    });
    getImageDimensions(file).then((dimension) => {
      if(dimension.width>dimension.height || dimension.width == dimension.height){
        if(dimension.width == dimension.height){
          settingsData.imageWidthUnit = settingsData.widthUnit/2;
          setOriWidth(settingsData.imageWidthUnit);
          settingsData.imageHeightUnit = getCorrectedHeight()/2;
          setOriHeight(settingsData.imageHeightUnit);
          settingsData.imageX = settingsData.imageWidthUnit/2;
          settingsData.imageY = settingsData.imageHeightUnit/2;
        }else{
          settingsData.imageWidthUnit = settingsData.widthUnit/2;
          setOriWidth(settingsData.imageWidthUnit);
          settingsData.imageHeightUnit = getCorrectedHeight()/2;
          setOriHeight(settingsData.imageHeightUnit);
          settingsData.imageX = settingsData.imageWidthUnit/2;
          settingsData.imageY = parseFloat(((settingsData.heightUnit-settingsData.imageHeightUnit)/2).toFixed(2));
        }
      }else{
        settingsData.imageHeightUnit = settingsData.heightUnit/2;
        setOriHeight(settingsData.imageHeightUnit);
        settingsData.imageWidthUnit = getCorrectedWidth()/2;
        setOriWidth(settingsData.imageWidthUnit);
        settingsData.imageX = parseFloat(((settingsData.widthUnit-settingsData.imageWidthUnit)/2).toFixed(2));
        settingsData.imageY = settingsData.imageHeightUnit/2;
      }
      onChange(settingsData);
  });
  }

  const onImageUnSelected = () => {
    setImageButton(true) 
    settingsData.image = undefined;
    settingsData.altImageText = '';
    onChange(settingsData);
  }
  
  const autoFixHeight = (value) =>{
        settingsData.imageHeightUnit = parseFloat(((value*settingsData.imageHeightUnit)/(settingsData.imageWidthUnit == 0 || settingsData.imageWidthUnit == null ? oriWidth : settingsData.imageWidthUnit)).toFixed(2));
        settingsData.imageWidthUnit = value;
        settingsData.imageX = parseFloat(((settingsData.widthUnit-settingsData.imageWidthUnit)/2).toFixed(2));
        settingsData.imageY = parseFloat(((settingsData.heightUnit-settingsData.imageHeightUnit)/2).toFixed(2));  
        onChange(settingsData);
  }

  const autoFixWidth = (value) =>{
    settingsData.imageWidthUnit = parseFloat(((value*settingsData.imageWidthUnit)/(settingsData.imageHeightUnit == 0 || settingsData.imageHeightUnit == null ? oriHeight : settingsData.imageHeightUnit)).toFixed(2));
    settingsData.imageHeightUnit = value;
    settingsData.imageX = parseFloat(((settingsData.widthUnit-settingsData.imageWidthUnit)/2).toFixed(2));
    settingsData.imageY = parseFloat(((settingsData.heightUnit-settingsData.imageHeightUnit)/2).toFixed(2));  
    onChange(settingsData);
}


  if(settingsData){
    return (
      <Card className={classNameString} style={{ marginLeft: "0px", marginBottom:'8px' }}>
        <Accordion sx={{boxShadow:'none'}}>
        <AccordionSummary
          expandIcon={<PiCaretDown fontSize={24} />}
        >
          <div>
            <div style={{fontSize:'24px'}}>Grid Settings</div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
        
        <CardText>
              <Grid style={{ marginLeft: "0px" }}>
                <Cell size={3}>
                 
              <SelectField
                id="discrete-default-value-slider"
                label="Grid unit size "
                fullWidth
                onChange={(value, selectedIndex) => {
                  console.log(typeof value)
                  const data = gridUnitSizes[selectedIndex];
                  const gridValues = data.gridValues.split('x');
                  settingsData.stepSize = value;
                  settingsData.heightUnit = gridValues[0];
                  settingsData.widthUnit = gridValues[1];
                  if(imageWidthGlobal > imageHeightGlobal || imageWidthGlobal == imageHeightGlobal) {
                    if(imageWidthGlobal == imageHeightGlobal){
                      settingsData.imageWidthUnit = settingsData.widthUnit/2;
                      setOriWidth(settingsData.imageWidthUnit);
                      settingsData.imageHeightUnit = getCorrectedHeight()/2;
                      setOriHeight(settingsData.imageHeightUnit);
                      settingsData.imageX = settingsData.imageWidthUnit/2;
                      settingsData.imageY = settingsData.imageHeightUnit/2;
                    }else{
                      settingsData.imageWidthUnit = settingsData.widthUnit/2;
                      setOriWidth(settingsData.imageWidthUnit);
                      settingsData.imageHeightUnit = getCorrectedHeight()/2;
                      setOriHeight(settingsData.imageHeightUnit);
                      settingsData.imageX = settingsData.imageWidthUnit/2;
                      settingsData.imageY = parseFloat(((settingsData.heightUnit-settingsData.imageHeightUnit)/2).toFixed(2));
                    }
                  } else{
                    settingsData.imageHeightUnit = settingsData.heightUnit/2;
                    setOriHeight(settingsData.imageHeightUnit);
                    settingsData.imageWidthUnit = getCorrectedWidth()/2;
                    setOriWidth(settingsData.imageWidthUnit);
                    settingsData.imageX = parseFloat(((settingsData.widthUnit-settingsData.imageWidthUnit)/2).toFixed(2));
                    settingsData.imageY = settingsData.imageHeightUnit/2;
                  }
                  onChange(settingsData);
                }}
                menuItems={gridUnitSizes}
                value={settingsData.stepSize ? settingsData.stepSize : 15}
              />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    value={settingsData.heightUnit}
                    label="Grid Height"
                    id={`text-height`}
                    type="number"
                    onChange={(value) => {                      
                      settingsData.heightUnit = value;
                      onChange(settingsData);
                    }}
                    helpText="grid height in number of base units : eg 20"
                  />
                </Cell>
                <Cell size={3}>
                  <TextField
                    className="textFieldClass"
                    value={settingsData.widthUnit}
                    label="Grid Width"
                    id={`text-width`}
                    type="number"
                    onChange={(value) => {
                      settingsData.widthUnit = value;
                      onChange(settingsData);
                    }}
                    helpText="grid width in number of base units : eg 20"
                  />
                </Cell>
                <Cell size={3}>
                  <SelectField
                      helpText="Select a grid color"
                      id="select-grid-color"
                      label="Grid Color"
                      fullWidth
                      onChange={(value) => {
                        settingsData.gridColor = value;
                        onChange(settingsData);
                      }}
                      menuItems={["dark","medium","light"]}
                      value={settingsData.gridColor}
                    />
                </Cell>
                <Cell size={3}>
                  <label
                      htmlFor={`allow-identical-vectors`}
                      className="vectors-toggle-label"
                    >
                      {"Allow Identical Vectors"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                    id={`allow-identical-vectors`}
                    name="Allow Identical Vectors"
                    onChange={(event) => {
                      settingsData.enableIdenticalVector = event.target.checked;
                      onChange(settingsData);
                    }}
                    checked={settingsData.enableIdenticalVector}
                  />
                </Cell>
                <Cell size={3}>
                  <label
                      htmlFor={`enable-border-check`}
                      className="vectors-toggle-label"
                    >
                      {"Show Border"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                    id={`enable-border-check`}
                    name="Enable Canvas Border"
                    onChange={(event) => {
                      settingsData.enableBorder = event.target.checked;
                      console.debug("settingsData.enableBorder", settingsData.enableBorder)
                      onChange(settingsData);
                    }}
                    checked={settingsData.enableBorder !== undefined && settingsData.enableBorder !== null ? settingsData.enableBorder : true}
                  />
                </Cell>
                <Cell size={3}>
                  <label
                      htmlFor={`enable-grid-check`}
                      className="vectors-toggle-label"
                    >
                      {"Show Grid Lines"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                    id={`enable-grid-check`}
                    name="Enable Grid Lines"
                    onChange={(event) => {
                      settingsData.enableGrid = event.target.checked;
                      onChange(settingsData);
                    }}
                    checked={settingsData.enableGrid}
                  />
                </Cell>
                {
                  settingsData.enableGrid && 
                  <Cell size={3}>
                    <label
                      htmlFor={`enable-dark-grid-lines`}
                      className="vectors-toggle-label"
                    >
                      {"Show Dark Grid Lines"}
                    </label>
                    <Toggle
                        icons={false}
                        width={230}
                        id={`enable-dark-grid-lines`}
                        name="Enable Grid Lines"
                        onChange={(event) => {
                          settingsData.enableDarkGridLine = event.target.checked;
                          onChange(settingsData);
                        }}
                        checked={settingsData.enableDarkGridLine}
                    />
                  </Cell>
                }

               {/*  <Cell size={3}>
                    <label
                      htmlFor={`enable-snap-to-gird`}
                      className="vectors-toggle-label"
                    >
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <span style={{ whiteSpace: "nowrap" }}>
                        Snap to Grid
                      </span>

                      <div style={{ width: "auto", flex: "0 0 auto" }}>
                        <SFInfoTooltip
                          tooltipText="The components/angle-magnitude can be integers if Snap to Grid is ON, and can be integers or continuous values if Snap to Grid is OFF."
                          placement="right"
                        />
                      </div>
                    </div>
                    </label>
                    <Toggle
                        icons={false}
                        width={230}
                        id={`enable-snap-to-gird`}
                        name="Snap to Grid"
                        onChange={(event) => {
                          let value = event.target.checked;
                          if (value && variableMap) {
                              let invalidVar = Array.from(variableMap.values()).find(
                                v => v.variableType === "RANGE CONTINUOUS"
                              );

                              if (answerList && answerList.length) {
                                invalidVar = false;
                                answerList.forEach(answer => {
                                  if (answer && answer.props && answer.props.vectorAnswerVariable && answer.props.vectorAnswerVariable.length) {
                                    answer.props.vectorAnswerVariable.forEach(answerVar => {
                                      if (answerVar && answerVar.variableType === "RANGE CONTINUOUS") {
                                        invalidVar = true
                                      }
                                    })
                                  }
                                })
                              }

                              if (invalidVar) {
                                NotificationManager.error("One or more answers use a continuous range. Please change it to proceed.");
                                return;
                              }
                            }

                          settingsData.isSnapToGridOff = !value;
                          onChange(settingsData);
                        }}
                        checked={!settingsData.isSnapToGridOff}
                    />
                  </Cell> */}

                <Cell size={5}>
                  <Box component="fieldset" style={{
                    borderRadius:'4px',
                    borderColor:'#888',
                    borderWidth:'1px',
                    overflow: 'visible'
                  }}>
                    
                    <legend>
                      <div style={{
                        display:'flex',
                        justifyContent:'center',
                      }}>
                        <div>
                          Student View
                        </div>
                        <div>
                         <span data-tip data-for='student-view-tooltip' style={{cursor:'pointer', marginLeft:'2px'}}>
                            <HiInformationCircle color="gray" fontSize={16} />
                          </span>
                        <ReactTooltip id='student-view-tooltip' place='right' effect="solid" className="react-tooltip-style">
                          <div style={{width:'400px'}}>
                            <span><strong>1. Snap to Grid:</strong> Automatically align items to the nearest grid point when moving or placing them</span>
                            <br /><br />
                            <span><strong>2. Show Snap to Grid Checkbox:</strong> Display a toggle that lets users enable or disable grid snapping</span>
                            <br /><br />
                            <span><strong>3. Snap to Grid Enabled by Default:</strong> Snap to Grid Checkbox is ticked on when the tool loads</span>
                          </div>
                        </ReactTooltip>
                      </div>
                      </div>
                     
                    </legend>
                    <div>
                      <label className="vectors-toggle-label">
                        <input
                          type="checkbox"
                          id="student-view-snap-to-grid"
                          checked={!settingsData.isStudentViewSnapToGridOff}
                          onChange={(event) => {
                            let value = event.target.checked;
                            settingsData.isStudentViewSnapToGridOff = !value;
                            
                            settingsData.showStudentSnapToGridTickbox = false;
                            settingsData.defaultCheckedStudentSnapToGridTickbox = false;

                            onChange(settingsData);
                          }}
                        />
                        {" "}Snap To Grid
                      </label>
                    </div>

                    {settingsData.isStudentViewSnapToGridOff ? (
                      <div>
                        <label className="vectors-toggle-label">
                          <input
                            type="checkbox"
                            id="show-student-snap-to-grid-tickbox"
                            checked={settingsData.showStudentSnapToGridTickbox}
                            onChange={(event) => {
                              let value = event.target.checked;
                              settingsData.showStudentSnapToGridTickbox = value;
                              settingsData.defaultCheckedStudentSnapToGridTickbox = false;
                              onChange(settingsData);
                            }}
                          />
                          {" "}Show Snap To Grid Tickbox
                        </label>
                      </div>
                    ) : null}

                    {settingsData.showStudentSnapToGridTickbox ? (
                      <div>
                        <label className="vectors-toggle-label">
                          <input
                            type="checkbox"
                            id="default-checked-student-snap-to-grid-tickbox"
                            checked={settingsData.defaultCheckedStudentSnapToGridTickbox}
                            onChange={(event) => {
                              let value = event.target.checked;
                              settingsData.defaultCheckedStudentSnapToGridTickbox = value;
                              onChange(settingsData);
                            }}
                          />
                          {" "}Snap To Grid Tickbox Default Checked
                        </label>
                      </div>
                    ) : null}
                  </Box>
                </Cell>


                <Cell size={3}>
                  <label
                      htmlFor={`show-coor-axes`}
                      className="vectors-toggle-label"
                    >
                      {"Show Coord. Axes"}
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                    id={`show-coor-axes`}
                    name="Select Grid Color"
                    onChange={(event) => {
                      settingsData.enableRuler = event.target.checked;
                      if(!event.target.checked) {
                        settingsData.rulerXPoint = "5";
                        settingsData.rulerYPoint = "5";
                        settingsData.rulerXLabel = 'x';
                        settingsData.rulerYLabel = 'y';
                        settingsData.rulerNXLabel = '';
                        settingsData.rulerNYLabel = '';
                      }
                      onChange(settingsData);
                    }}
                    checked={settingsData.enableRuler}
                  />
                </Cell>
                <Cell size={3}>
                  <label
                    htmlFor={`hide-question-vectors-grid-settings`}
                    className="vectors-toggle-label"
                  >
                    {"Hide Grid In The Question"}
                  </label>
                  <Toggle
                    icons={false}
                    width={230}
                    id={`hide-question-vectors-grid-settings`}
                    name="Hide Grid In The Question"
                    onChange={(event) => {
                      settingsData.hideQuestionVectors = event.target.checked;
                      onChange(settingsData);
                    }}
                    checked={settingsData.hideQuestionVectors ? settingsData.hideQuestionVectors : false}
                    className="rp-fraction-checkbox"
                    label="Hide Grid In The Question"
                  />
                </Cell>
                </Grid>
                
              {
                settingsData.enableRuler?
                (
                  <React.Fragment>
                  <Grid style={{ marginLeft: "0px" }}>
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerXPoint}
                      label="X Axis Origin"
                      id={`vector-cord-x-point`}
                      type="number"
                      onChange={(value) => {
                        settingsData.rulerXPoint = value;
                        onChange(settingsData);
                      }}
                      helpText="x axis origin"
                    />
                  </Cell>
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerXLabel}
                      label="+x axis Label"
                      id={`vector-cord-x-label`}
                      type="text"
                      onChange={(value) => {
                        settingsData.rulerXLabel = value;
                        onChange(settingsData);
                      }}
                      helpText="+x axis label"
                    />
                  </Cell>
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerNXLabel}
                      label="-x axis Label"
                      id={`vector-cord-nx-label`}
                      type="text"
                      onChange={(value) => {
                        settingsData.rulerNXLabel = value;
                        onChange(settingsData);
                      }}
                      helpText="-x axis label"
                    />
                  </Cell>
                  </Grid>
                  <Grid style={{ marginLeft: "0px" }}>
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerYPoint}
                      label="Y Axis Origin"
                      id={`vector-cord-y-origin`}
                      type="number"
                      onChange={(value) => {
                        settingsData.rulerYPoint = value;
                        onChange(settingsData);
                      }}
                      helpText="y axis origin"
                    />
                  </Cell>
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerYLabel}
                      label="+y axis Label"
                      id={`vector-cord-y-label`}
                      type="text"
                      onChange={(value) => {
                        settingsData.rulerYLabel = value;
                        onChange(settingsData);
                      }}
                      helpText="+y axis label"
                    />
                  </Cell>   
                  <Cell size={4}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.rulerNYLabel}
                      label="-y axis Label"
                      id={`vector-cord-ny-label`}
                      type="text"
                      onChange={(value) => {
                        settingsData.rulerNYLabel = value;
                        onChange(settingsData);
                      }}
                      helpText="-y axis label"
                    />
                  </Cell>
                  <Cell size={3}>
                    <label
                      htmlFor={`show-scale`}
                      className="vectors-toggle-label"
                    >
                      Show Scale
                    </label>
                    <Toggle
                      icons={false}
                      width={230}
                    id={`show-scale`}
                    name="Show Scale"
                    onChange={(event) => {
                      settingsData.showScale = event.target.checked;
                      settingsData.scale = 5;
                      onChange(settingsData);
                    }}
                    checked={settingsData.showScale ?? false}
                  />
                  </Cell>
                  {(settingsData.showScale ?? false) ? 
                    <Cell size={3}>
                      <TextField
                        className="textFieldClass"
                        value={settingsData.scale ??  5}
                        label="Scale"
                        id={`scale`}
                        type="number"
                        min={1}
                        onChange={(value) => {
                          settingsData.scale = parseInt(value, 10);
                          onChange(settingsData);
                        }}
                        // helpText="y position of image in number of base units : eg 20"
                      />
                    </Cell>
                  : null}
                  </Grid>
                  </React.Fragment>
                ):null
              }
              {settingsData.image ? ( 
                <React.Fragment>
                  <Grid style={{ marginLeft: "0px" }}>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.imageWidthUnit}
                      label="Image Width"
                      id={`vector-image-width`}
                      type="number"
                      onChange={(value) => {
                        if(!isNaN(parseFloat(value))){
                          setOriWidth(parseFloat(value))
                          autoFixHeight(parseFloat(value));
                        }
                        settingsData.imageWidthUnit = parseFloat(value);
                        onChange(settingsData); 
                      }}
                      helpText="width of the image in number of base units : eg 20"
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.imageHeightUnit}
                      label="Image Height"
                      id={`vector-image-height`}
                      type="number"
                      onChange={(value) => {
                        if(!isNaN(parseFloat(value))){
                          setOriHeight(parseFloat(value))
                          autoFixWidth(parseFloat(value));
                        }
                        settingsData.imageHeightUnit = parseFloat(value);
                        onChange(settingsData);
                      }}
                      helpText="width of the image in number of base units : eg 20"
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.imageX}
                      label="Image Origin X"
                      id={`vector-image-x`}
                      type="number"
                      onChange={(value) => {
                        settingsData.imageX = parseFloat(value);
                        onChange(settingsData);
                      }}
                      helpText="x position of image in number of base units : eg 20"
                    />
                  </Cell>
                  <Cell size={3}>
                    <TextField
                      className="textFieldClass"
                      value={settingsData.imageY}
                      label="Image Origin Y"
                      id={`vector-image-y`}
                      type="number"
                      onChange={(value) => {
                        settingsData.imageY = parseFloat(value);
                        onChange(settingsData);
                      }}
                      helpText="y position of image in number of base units : eg 20"
                    />
                  </Cell>
                  </Grid>
                  </React.Fragment>
              ) : null}
              <Grid style={{ marginLeft: "0px" }}>
              {
                  settingsData.image && (
                    <Cell size={3}>
                    <TextField
                      id="vector-image-alt-text"
                      label="Image alt text"
                      placeholder="Image alt text"
                      value={settingsData.altImageText}
                      onChange={(value) => {
                        settingsData.altImageText = value;
                        onChange(settingsData);
                      }}
                    />
                    </Cell>
                  )
                }
              {
                 imageButton && !settingsData.image ? (<Cell size={4}>
                 <FileInput
                   id="vector-image"
                   accept="image/*"
                   name="images"
                   label="Add an image to canvas"
                   labelStyle={{inlineSize: 'max-content'}}
                   onChange={onImageSelected}
                 />
                 </Cell>) :
                  <React.Fragment>
                    <Cell size={4}>
                       <label
                          htmlFor={`show-image-grid-settings`}
                          className="vectors-toggle-label"
                        >
                          {"Show Image In Answers"}
                        </label>
                        <Toggle
                          icons={false}
                          width={230}
                          id={`show-image-grid-settings`}
                          name="Show Image In Answers"
                          onChange={(event) => {
                            settingsData.showImageInAnswers = event.target.checked;
                            onChange(settingsData);
                          }}
                          checked={settingsData.showImageInAnswers ? settingsData.showImageInAnswers : false}
                          className="rp-fraction-checkbox"
                          label="Show Image In Answers"
                        />
                    </Cell>
                    <Cell size={4}>
                      <Button
                        flat
                        secondary
                        swapTheming
                        onClick={onImageUnSelected}
                      >
                        Clear Image
                      </Button>
                    </Cell>
                  </React.Fragment>

                }
              </Grid>
        </CardText>
        </AccordionDetails>
      </Accordion>
      </Card>
    );
  }else{
    return null;
  }
  
};

export default VectorCanvasSettings;
